import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import SettingsSection from "./SettingsSection";

export default function FormFieldsManager() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/field-configs").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const patch = async (key, body) => {
    try {
      const { data } = await api.patch(`/field-configs/${key}`, body);
      setRows((rs) => rs.map((r) => (r.key === key ? data : r)));
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  };
  return (
    <SettingsSection title="Form Fields" description="Enable/disable and mark required the standard ticket fields. Subject, Description and Project are always required.">
      <div className="surface-card p-5">
        <div className="divide-y divide-slate-100">
          {rows.map((f) => (
            <div key={f.key} className="py-2.5 first:pt-0">
              <div className="flex items-center justify-between gap-3">
                <span className="text-slate-800 text-sm">{f.label}</span>
                <div className="flex items-center gap-4 text-sm">
                  <label className="flex items-center gap-1.5">
                    <input type="checkbox" checked={f.enabled} onChange={(e) => patch(f.key, { enabled: e.target.checked })} />
                    Enabled
                  </label>
                  <label className={`flex items-center gap-1.5 ${f.enabled ? "" : "opacity-40"}`}>
                    <input type="checkbox" disabled={!f.enabled} checked={f.required} onChange={(e) => patch(f.key, { required: e.target.checked })} />
                    Required
                  </label>
                </div>
              </div>
              {f.key === "request_type" && f.enabled && f.required && (
                <div className="mt-2 ml-3 pl-3 border-l-2 border-slate-100 flex items-center justify-between gap-3">
                  <span className="text-xs text-slate-500">
                    Sub-types — require at least one when the chosen request type has sub-types
                  </span>
                  <label className="flex items-center gap-1.5 text-sm shrink-0">
                    <input
                      type="checkbox"
                      checked={!!f.subtypes_required}
                      onChange={(e) => patch(f.key, { subtypes_required: e.target.checked })}
                    />
                    Required
                  </label>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="surface-card p-4 text-xs text-slate-500 space-y-1">
        <div>Always on: <span className="text-slate-700 font-medium">Subject, Description, Project</span></div>
        <div>Disabling a field hides it from the ticket form, ticket details and other pages — even for tickets that already have data recorded. Re-enabling shows the data again.</div>
      </div>
    </SettingsSection>
  );
}
